<template>
  <v-row>
    <v-col cols="2" offset="2">
      <v-btn v-if="activeIndex !== 0" block @click="back">Cofnij</v-btn>
      <v-btn v-else block :loading="backLoading" @click="goBack">Wróć do szkolenia</v-btn>
    </v-col>
    <v-col cols="2" offset="4">
      <v-btn
        v-if="screens.length !== activeIndex + 1"
        color="green lighten-2"
        block
        :loading="nextLoading"
        @click="next"
        >Następny slajd</v-btn
      >
      <v-btn
        v-else-if="!hasTests && screens.length === activeIndex + 1"
        color="green lighten-2"
        :loading="finishLoading"
        block
        @click="finish"
        >Zakończ</v-btn
      >
      <FinishLessonDialog
        v-else-if="hasTests && screens.length === activeIndex + 1"
        :loading="finishLoading"
        @yesClicked="finish"
      />
    </v-col>
  </v-row>
</template>

<script>
import FinishLessonDialog from '@/components/course/navigation/FinishLessonDialog.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    FinishLessonDialog
  },
  props: {
    activeIndex: {
      type: Number,
      required: true
    },
    screens: {
      type: Array,
      required: true
    },
    finishPrompt: {
      type: Boolean,
      default: false
    },
    backLoading: {
      type: Boolean,
      default: false
    },
    nextLoading: {
      type: Boolean,
      default: false
    },
    finishLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      activeElement: state => state.executingCourse.activeElement
    }),
    hasTests() {
      const element = JSON.parse(this.activeElement.item.execution);
      return !!element.screens.find(screen => screen.type === 'TestScreenExecution');
    }
  },
  methods: {
    ...mapActions(['getCourseToExecute']),
    async goBack() {
      this.$emit('update:backLoading', true);
      await this.getCourseToExecute({
        courseId: this.$route.params.courseId
      });
      await this.$router.push(`/course/${this.$route.params.courseId}`);
      this.$emit('update:backLoading', false);
    },
    back() {
      this.$emit('back', { newIndex: this.activeIndex - 1 });
    },
    next() {
      this.$emit('next', { newIndex: this.activeIndex + 1 });
    },
    finish() {
      this.$emit('finish');
    }
  }
};
</script>
